import CanVisitMiddleware from '@/middleware/CanVisitMiddleware.js';
import GateKeeperMiddleware from '@/middleware/GateKeeperMiddleware.js';

const courseIdParam = to => {
    const courseId = to?.params?.courseId;

    if (courseId === undefined || courseId === null || courseId === '') {
        return null;
    }

    return courseId;
};

async function canAccessQuizAttempt({ gateKeeper, to }) {
    const courseId = courseIdParam(to);

    if (courseId === null || !(await gateKeeper.userHasAccessToCourse(courseId))) {
        return false;
    }

    const hasCreatePermission =
        gateKeeper.userHasPermission('create a quiz attempt') ||
        gateKeeper.userHasGroupPermissionWithinCourse(courseId, 'create a quiz attempt');

    if (to.params.attemptId) {
        return (
            hasCreatePermission ||
            gateKeeper.userHasPermission('view a quiz attempt') ||
            gateKeeper.userHasGroupPermissionWithinCourse(courseId, 'view a quiz attempt')
        );
    }

    return hasCreatePermission;
}

export default [
    {
        path: '/courses/:courseId/activities/:activityId/quiz/:id/:attemptId?',
        component: () => import('@/pages/courses/quizzes/Quiz.vue'),
        props: true,
        children: [
            {
                name: 'quiz-attempt',
                path: '',
                component: () => import('@/components/quiz-attempt/QuizAttempt.vue'),
                meta: {
                    title: 'Quiz',
                    middleware: [GateKeeperMiddleware],
                    ability: canAccessQuizAttempt,
                },
            },
        ],
    },

    {
        path: '/courses/:courseId/activities/:activityId/quiz/:id/:attemptId?/preview',
        component: () => import('@/pages/courses/quizzes/Quiz.vue'),
        props: true,
        children: [
            {
                name: 'quiz-attempt-preview',
                path: '',
                component: () => import('@/components/quiz-attempt/QuizAttempt.vue'),
                meta: {
                    title: 'Quiz',
                    middleware: [GateKeeperMiddleware],
                    ability: async ({ gateKeeper, to }) => {
                        const courseId = courseIdParam(to);

                        return (
                            courseId !== null &&
                            (await gateKeeper.userHasAccessToCourse(courseId)) &&
                            gateKeeper.userHasAccessToPreviewQuiz(courseId)
                        );
                    },
                },
            },
        ],
    },

    {
        path: '/courses/:courseId/activities/:activityId/quiz/:id',
        component: () => import('@/pages/courses/quizzes/Quiz.vue'),
        props: true,
        children: [
            {
                name: 'quiz-attempt-start',
                path: '',
                component: () => import('@/components/quiz-attempt/QuizAttempt.vue'),
                meta: {
                    title: 'Quiz',
                    middleware: [GateKeeperMiddleware],
                    ability: canAccessQuizAttempt,
                },
            },
        ],
    },
    {
        path: '/courses/:courseId/activities/:activityId/manage-quiz-attempts',
        component: () => import('@/pages/courses/quizzes/QuizAttemptManager.vue'),
        name: 'manage-quiz-attempts',
        meta: {
            title: 'Manage Quiz',
            // opt into full-width via meta.dataTablePage
            dataTablePage: true,
            middleware: [CanVisitMiddleware],
            ability: ({ gateKeeper, to }) =>
                gateKeeper.userHasGroupPermissionWithinCourse(
                    to.params.courseId,
                    "create another user's quiz attempt"
                ) || gateKeeper.userHasPermission("create another user's quiz attempt"),
        },
        props: true,
    },
];
